// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drop-input {
  background-color: #f5f5f5;
  border: 2px dashed #a7a8aa;
  min-height: 140px;
  min-width: 300px;
  margin: auto;
}
.vertical-separator {
  border: 0.5px solid #97999b;
  height: auto;
  grid-area: vertical-separator;
}
`, "",{"version":3,"sources":["webpack://./src/css/inputDrop.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;AAC/B","sourcesContent":[".drop-input {\n  background-color: #f5f5f5;\n  border: 2px dashed #a7a8aa;\n  min-height: 140px;\n  min-width: 300px;\n  margin: auto;\n}\n.vertical-separator {\n  border: 0.5px solid #97999b;\n  height: auto;\n  grid-area: vertical-separator;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
